export default function PayrollEntryDetailPage() {
  return null;
}
